import React from "react";
import "./orderSubmitted.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

export default function OrderSubmitted({
  remainingMinutes,
  remainingSeconds,
  showTime,
}) {
  return (
    <div className="order-confiramtion-container">
      <div className="order-confirm-box">
        <div className="confirm-details">
          <div className="order-message">سفارش شما با موفقیت ثبت شد</div>
          <div className="order-remaining-time">
            {showTime ? (
              <>
                <span>زمان تقریبی رسیدن سفارش شما</span>
                <span>
                  {remainingMinutes.toLocaleString("en-US", {
                    minimumIntegerDigits: 2,
                  })}
                  :
                  {remainingSeconds.toLocaleString("en-US", {
                    minimumIntegerDigits: 2,
                  })}
                </span>
              </>
            ) : (
              <span> سفارش در انتظار تایید می باشد </span>
            )}
          </div>
        </div>
        <div className="order-contact">
          مشکلی پیش امده؟ با ما تماس بگیرید
          <a className="order-contact-icon" href="tel:+9803136680995">
            <FontAwesomeIcon icon={faPhone} />
          </a>
        </div>
      </div>
    </div>
  );
}
